import React, { Component } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.css';
import '../styles/carousel.css'
class Carousell extends Component {
  constructor(props) {
    super(props)

  }


  render() {

    return (
      <div className="" id="carousel" >
        <Carousel fade>
          <Carousel.Item>
            <img
              className="img1 d-flex justify-content-center"
              src="images/maxresdefault.jpg"
              alt="First slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="img2 d-flex justify-content-center"
              src="images/car1.jpg"
              alt="Second slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="img3 d-flex justify-content-center"
              src="images/car2.jpg"
              alt="Third slide"
            />
          </Carousel.Item>
        </Carousel>
      </div>
    );
  }
}

export default Carousell;